import Vue from 'vue';
import { isMobile } from 'utils/general';

export default (el) =>
  new Vue({
    el,
    name: 'Animated steps',
    components: {
      'animated-step': () => import('./animated-step.vue'),
    },
    data() {
      return {
        blocks: [],
        activeIndex: 0,
      };
    },
    created() {
      this.blocks = this.$children;
    },
  });
